export default __webpack_public_path__ + "static/member-plant-1-1-755f8b2d83dd0d387ad4882d9f91f2f4.png";